<template>
  <b-form novalidate>
    <template v-if="showRpoBox">
      <rpo-search-box v-if="slovakRpo" v-model="contractor.organization" style="width: 400px;" :fetchedOrganization="fetchedOrg"/>
      <czech-rpo-search-box v-if="czechRpo" v-model="contractor.organization" style="width: 400px;" :fetchedOrganization="fetchedOrg"/>
    </template>
    <b-form-input v-else v-model="contractor.foreignCin" type="text" required placeholder="Zadajte IČO alebo názov spoločnosti" style="width: 400px" />
    <country-select v-model="contractor.country" :fetchedCountry="fetchedOrg ? $attrs.value.country : null" style="width: 400px;" />
  </b-form>
</template>

<script>
import CzechRpoSearchBox from '@/components/Custom/CzechRpoSearchBox'
import CountrySelect from "@/components/Custom/CountrySelect"
import RpoSearchBox from '../../components/Custom/RpoSearchBox.vue'

export default {
  name: "ContractorSelect",
  components: { RpoSearchBox, CountrySelect, CzechRpoSearchBox },
  props: ['offerIndex', 'isGroup', 'isMainContractor'],
  data () {
    return {
      contractor: {
        country: '',
        organization: {
          cin: null
        },
        foreignCin: null
      }
    }
  },
  created () {
    if (this.$attrs && this.$attrs.value && (this.$attrs.value.country !== 'SK' && this.$attrs.value.country !== 'CZ')) {
      this.contractor.country = this.$attrs.value.country,
      this.contractor.foreignCin = this.$attrs.value.cin
    }
  },
  computed: {
    fetchedOrg () {
      if (this.$attrs && this.$attrs.value) {
        return this.$attrs.value.fetched ? this.$attrs.value : null
      }
      return null
    },
    showRpoBox () {
      return this.slovakRpo || this.czechRpo
    },
    slovakRpo () {
      return this.contractor.country === 'SK'
    },
    czechRpo () {
      return this.contractor.country === 'CZ'
    }
  },
  watch: {
    contractor: {
      handler () {
        if ((this.contractor.country === 'SK' || this.contractor.country === 'CZ') && !this.contractor.organization.cin) {
          return
        }
        if ((this.contractor.country !== 'SK' && this.contractor.country !== 'CZ') && !this.contractor.foreignCin) {
          return
        }
        this.$emit('input', {
          country: this.contractor.country,
          foreignCin: (this.contractor.country !== 'SK' && this.contractor.country !== 'CZ') ? this.contractor.foreignCin.replace(/\s/g, "") : null,
          organization: this.contractor.country === 'SK' || this.contractor.country === 'CZ' ? this.contractor.organization : null
        })
      },
      deep: true
    }
  }
}
</script>